import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { getDefaultStore } from 'jotai';

import { hoverInfoEnabledAtom } from '../hover-info/hover-info-atom.js';
import { ToolbarItem } from './toolbar-item.js';

import type { ElementType } from 'react';
import type { IToolbarItem, IToolbarItemState } from './toolbar-item.js';

interface IOwnState extends IToolbarItemState {}

/**
 * Toolbar toggle for the module hover tooltip: a click or its key flips the shared hover-info
 * preference, and its active state is that preference. Only the hover tooltip is gated by it —
 * right-clicking a module still opens the module info popover while it is off.
 */
export class ToggleHoverInfoToolbarItem extends ToolbarItem<IOwnState> implements IToolbarItem {
	public static readonly ItemId = 'togglehoverinfo';
	id: string = ToggleHoverInfoToolbarItem.ItemId;
	title = 'Show/hide module hover info';
	keyEventName = 'TOGGLE_HOVER_INFO';
	defaultKeyBinding = 'shift+h';
	iconElement: ElementType = InfoOutlinedIcon;
	includeInHistory = false;

	/**
	 * Does nothing. The active state is read from the shared preference rather than held here, so
	 * there is nothing to write back — and the base class reports "inactive" as it unmounts, which
	 * would otherwise switch the preference off every time the toolbar goes away.
	 */
	public onActiveStateChanged(): void {
		// Empty on purpose
	}

	/** Flips the preference, so the key binding toggles the hover tooltip. */
	public onKeyEvent(): void {
		this.togglePreference();
	}

	/** Flips the preference, so clicking the button toggles the hover tooltip. */
	public onClick(): void {
		this.togglePreference();
	}

	/** Flips the shared hover-info preference. */
	private togglePreference(): void {
		const store = getDefaultStore();
		store.set(hoverInfoEnabledAtom, !store.get(hoverInfoEnabledAtom));
	}
}
